'use es6';

import * as ImmutableAPI from 'crm_data/api/ImmutableAPI';
export function getCallingAdminSettings() {
  return ImmutableAPI.get('calling-orchestration/v1/settings/admin');
}